import { FormikValuesUpdatePassword } from "./interfaceValues";

export const initialValuesFormikUpdatePassword: FormikValuesUpdatePassword = {
  email: "",
  newPass: "",
  newPassConfirmation: "",
};